import { ESTADOS_UF } from "./localidades";

// Municipios do estado, para o campo Cidade acompanhar o Estado escolhido.
// Fonte: API publica de localidades do IBGE (sem chave). Resultado em cache por UF;
// se a consulta falhar devolve null e o campo segue como texto livre.
const semAcento = (t) => String(t || "").normalize("NFD").replace(/[̀-ͯ]/g, "").trim().toLowerCase();
const cache = {};

export function ufDoEstado(nome) {
  const alvo = semAcento(nome);
  const achado = ESTADOS_UF.find((e) => semAcento(e.nome) === alvo || e.uf.toLowerCase() === alvo);
  return achado ? achado.uf : null;
}

export async function municipiosDoEstado(nomeEstado) {
  const uf = ufDoEstado(nomeEstado);
  if (!uf) return null;
  if (cache[uf]) return cache[uf];
  try {
    const r = await fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios?orderBy=nome`);
    if (!r.ok) return null;
    const lista = (await r.json()).map((m) => m.nome);
    cache[uf] = lista;
    return lista;
  } catch (e) {
    return null;
  }
}

// Devolve o nome oficial (com a grafia da lista) ou null se nao existir no estado.
export function acharMunicipio(lista, digitado) {
  const alvo = semAcento(digitado);
  return (lista || []).find((m) => semAcento(m) === alvo) || null;
}
